import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { InputContainer } from "./styled";
import { toast } from "react-toastify";
import api from "../../api/axios";
import dayjs from "dayjs";

export const ApplyProfessionalModal = ({ open, user, onClose }) => {
  const [oportunities, setOportunities] = useState([]);
  const [selectedOportunity, setSelectedOportunity] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [values, setValues] = useState({
    professional: "",
    oportunity: "",
  });

  const getOportunities = async () => {
    try {
      const { data } = await api.get("/oportunity/list-short");
      setOportunities(data);
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.log(err);
    }
  };

  const getSelectedOportunity = async (id) => {
    try {
      const { data } = await api.get("/oportunity/search/" + id);
      setSelectedOportunity(data);
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.log(err);
    }
  };

  const handleClose = () => {
    resetValues();
    onClose();
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    if (!values.oportunity) {
      toast.warn("Selecione uma oportunidade");
      return;
    }

    try {
      await api.post("/application/create", values);

      toast.success("Vinculação criada!");
      handleClose();
    } catch (err) {
      toast.error("Ocorreu um erro: " + err.response.data.message);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const resetValues = () => {
    setValues({
      ...values,
      oportunity: "",
    });
    setSelectedOportunity(null);
  };

  useEffect(() => {
    getOportunities();
  }, []);

  useEffect(() => {
    if (user && user._id) setValues({ ...values, professional: user._id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (values.oportunity) getSelectedOportunity(values.oportunity);
  }, [values.oportunity]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">Selecionar Oportunidade</DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            width: "100%",
            minWidth: "300px",
            gap: "1.5rem",
          }}
        >
          <InputContainer>
            <label for="oportunity">Oportunidade:</label>
            <Select
              id="oportunity"
              name="oportunity"
              value={values.oportunity}
              onChange={(e) =>
                setValues({ ...values, oportunity: e.target.value })
              }
            >
              {oportunities.map((item) => (
                <MenuItem
                  value={item._id}
                >{`${item.cargo} (${item.empresa})`}</MenuItem>
              ))}
            </Select>
          </InputContainer>
          <div style={{ margin: "0 auto" }}>
            {selectedOportunity && (
              <div
                style={{
                  backgroundColor: "#f2f2f2",
                  width: "250px",
                  borderRadius: "5px",
                  padding: "20px",
                  border:
                    selectedOportunity.status === "ativa"
                      ? "1px solid #104467"
                      : "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "15px",
                  }}
                >
                  <h2 style={{ color: "#104467", fontSize: "1rem" }}>
                    {selectedOportunity.cargo}
                  </h2>
                </div>
                <div style={{ margin: "5px 0" }}>
                  <span style={{ fontSize: "0.8rem" }}>
                    {`${dayjs(selectedOportunity.inicio_vigencia).format(
                      "DD/MM/YYYY",
                    )} - ${
                      selectedOportunity.fim_vigencia
                        ? dayjs(selectedOportunity.fim_vigencia).format(
                            "DD/MM/YYYY",
                          )
                        : "Indefinido"
                    }`}
                  </span>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxHeight: "75px",
                    textAlign: "justify",
                    fontSize: "0.9rem",
                    overflowY: "auto",
                    textOverflow: "ellipsis",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <span>{`Oportunidade na empresa ${selectedOportunity.empresa}`}</span>
                </div>
              </div>
            )}
          </div>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button
          sx={{ color: "#104467" }}
          disabled={isLoading}
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          disabled={isLoading}
          onClick={handleSubmit}
          variant="contained"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
